import OrganizationService from "../../../services/organization";
import * as types from "./mutationTypes";
import ErrorHandler from "../../../tools/errorHandler";
import { i18n } from "@/boot/i18n";
import { getDefaultReportRange, getDefaultReport } from "./controlPanelState";

export default {
  initState({ dispatch }) {
    //Init control panel state
    dispatch("organization/getSegments", null, { root: true });
    dispatch("user/getTrackUsers", null, { root: true });
  },
  clearState({ dispatch, commit }) {
    //Clear control panel state
    dispatch("user/clearTrackUsers", null, { root: true });
    dispatch("organization/clearSegments", null, { root: true });
    commit(types.CLEAR_CONTROL_PANEL);
  },
  setControlPanelSuccess({ commit }, organization) {
    commit(types.SET_CONTROL_PANEL, organization);
  },
  setReportSuccess({ commit }, report) {
    commit(types.SET_REPORT, report);
  },
  initReportState({ commit }) {
    commit(types.SET_REPORT_RANGE, getDefaultReportRange());
    commit(types.SET_REPORT, getDefaultReport());
  },
  clearReportState({ commit }) {
    commit(types.CLEAR_REPORT_RANGE);
    commit(types.CLEAR_REPORT);
  },
  setBillingCycle({ commit }, value) {
    commit(types.SET_BILLING_CYCLE, value);
  },
  setContractedCredits({ commit }, value) {
    commit(types.SET_CONTRACTED_CREDITS, value);
  },
  setContractExpiration({ commit }, value) {
    commit(types.SET_CONTRACT_EXPIRATION, value);
  },
  setDueDate({ commit }, value) {
    commit(types.SET_DUE_DATE, value);
  },
  setResponsible({ commit }, value) {
    commit(types.SET_RESPONSIBLE, value);
  },
  async getOne({ dispatch }, organizationUUID) {
    try {
      const response = await OrganizationService.getOne(organizationUUID);
      const data = {
        ...response.data.data
      };
      delete data.permissions;
      dispatch("setControlPanelSuccess", data);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async update({ state, dispatch }) {
    const organization = state.organization;
    try {
      await OrganizationService.update(organization);

      dispatch("ui/showToastSuccess", i18n.t("organization.messages.update_success"), { root: true });
      return true;
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  async getReport({ dispatch, state }) {
    try {
      const filter = {
        ["filter.starts_at"]: state.reportRange.starts_at,
        ["filter.ends_at"]: state.reportRange.ends_at
      };
      const response = await OrganizationService.getReport(state.organization.uuid, filter);
      if (response.data.data) dispatch("setReportSuccess", response.data.data);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  setReportRange({ commit }, { start, end }) {
    commit(types.SET_REPORT_RANGE, { starts_at: start, ends_at: end });
  },
  async handleActivate({ commit, dispatch, state }, { activate, reason }) {
    try {
      await OrganizationService.changeStatus(state.organization.uuid, { activate, reason });
      commit(types.SET_ACTIVATE, activate);
      commit(types.SET_REASON, reason);
      dispatch("ui/showToastSuccess", i18n.t("controlPanel.messages.status_success"), { root: true });
    } catch (e) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(e), { root: true });
    }
  }
};
